<template>
  <div class="home">
    <!-- <Home v-if="false" /> -->
    <MovieHome v-if="true" />
  </div>
</template>

<script>
// import Home from "@/components/ecommerceTwo/Pages/HomeC";
import MovieHome from "@/components/Movie/HomeC";
export default {
  name: "HomeView",

  components: {
    // Home,
    MovieHome,
  },
};
</script>
